<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Ajouter un Third Party</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      />
    </div>
    <vs-divider class="mb-0" />
    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="px-3 mt-2">
        <vs-input
          v-model="form.username"
          :danger="errors_data.username ? true : false"
          :danger-text="errors_data.username ? errors_data.username[0] : ''"
          label="Nom d'utilisateur"
          class="w-full"
        ></vs-input>
      </div>
      <div class="px-3 mt-2">
        <vs-input
          v-model="form.password"
          :danger="errors_data.password ? true : false"
          :danger-text="errors_data.password ? errors_data.password[0] : ''"
          type="password"
          label="Mot de passe"
          class="w-full"
        ></vs-input>
      </div>
    </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button @click="addThirdParty" class="mr-6">Soumettre</vs-button>
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Annuler</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
const DEFAULT_FORM = {
  username: "",
  password: "",
};
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  components: { VuePerfectScrollbar },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    callBackFunction: {
      type: Function,
    },
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      errors_data: [],
      form: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
        this.errors_data = [];
      },
    },
  },
  methods: {
    addThirdParty() {
      this.$vs.loading();
      this.$http
        .post("/third/create", this.form)
        .then((response) => {
          this.$vs.loading.close();
          if (response.data.status) {
            window.GETCCMT.success("Opération éffectuée", response);
            this.callBackFunction(response.data);
            this.form = { ...DEFAULT_FORM };
            this.$emit("closePrompt");
          } else {
            window.GETCCMT.error({ message: "Opération échouée." });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.errors_data = error.response.data.errors;
        });
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 350px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
